import { AfterViewInit, Component, ElementRef, Renderer2, inject, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FilledButtonComponent } from '@partners/ui';

@Component({
  standalone: true,
  selector: 'submit-button',
  template: `
    <filled-button
      type="submit"
      [formName]="formName()"
      mat-button
      class="primary-action-button"
      [disabled]="disabled()"
    >
      <ng-content></ng-content>
    </filled-button>
  `,
  imports: [FilledButtonComponent, MatButtonModule],
  host: {
    class: 'submit-button'
  }
})
export class SubmitButtonComponent implements AfterViewInit {
  formName = input<string>();

  #renderer = inject(Renderer2);
  #element = inject(ElementRef);

  disabled = input<boolean>(false);

  constructor() {}

  ngAfterViewInit(): void {
    const nativeButton = this.#element.nativeElement.querySelector('button');
    this.#renderer.setAttribute(nativeButton, 'form', this.formName());
  }
}
